import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/industries/page.tsx");
